import createRouter from 'router5'
import browserPlugin from 'router5/plugins/browser'

export type Route = {
  name: string,
  params: Object,
  path: string,
  meta: Object
}

export type TransitionSuccessPayload = {
  route: Route,
  previousRoute: ?Route,
}

const createRoute = (name, path, children) => ({
  name, path, children
})

const routes = [
  createRoute('home', '/'),
  createRoute('add-hospital', '/add-hospital'),
  createRoute('place-detail', '/place-detail?place'),
  createRoute('place-list', '/place-list?city&district&page'),
  createRoute('map', '/map?place'),
  createRoute('sign-in', '/sign-in'),
  createRoute('register', '/register'),
  createRoute('register-success', '/register-success'),
]

const options = {
  defaultRoute: 'home'
}

export const router = createRouter(routes, options)
.usePlugin(browserPlugin({
  useHash: false, 
}))
